
// Define App.
(function (angular, app) {
    "use strict";
    angular.module(app.modules.app.name, [
        "ngRoute"
        , "ngTouch"
        , "ngResource"
        , "angular-loading-bar"
        , "smoothScroll"
        , "ngDropdowns"
        , "ui.mask"
        , app.modules.common.name
        , app.modules.course.name
        , app.modules.group.name
        , app.modules.outing.name
        , app.modules.invitation.name
        , app.modules.member.name
        , app.modules.scoring.name
        , app.modules.handicap.name
        , app.modules.view.name
        , app.modules.ui.name
        , 'reports'
        , 'memories'
        , 'ngclipboard'
    ]);
}(angular, app));

